module.exports = __webpack_public_path__ + "static/media/SellerboxGuideRank.5486a892.png";